<link rel="ractive" href="./r-meta.html" name="r-meta">
<link rel="ractive" href="./r-serialize.html" name="r-serialize">

{{#partial meta}}
	<!-- Dynamic metadata that may change between pages. -->
	<meta name="viewport" content="width=device-width, initial-scale=1">
	<meta name="description" content="{{description || 'Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.'}}">
	<meta name="keywords" content="globalping, jsdelivr, free, open source, oss">
	<meta property="og:locale" content="en_US">
	<meta property="og:type" content="website">
	<meta property="og:title" content="{{ogTitle || title || 'Globalping - Internet and web infrastructure monitoring and benchmarking'}}">
	<meta property="og:description" content="{{ogDescription || description || 'Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.'}}">
	<meta property="og:url" content="{{@shared.serverHost}}{{@shared.actualPath}}">
	<meta property="og:site_name" content="Globalping">

	{{#if openGraphImage}}
	<meta property="og:image" content="{{openGraphImage}}">
	<meta property="og:image:secure_url" content="{{openGraphImage}}">
	<meta property="og:image:width" content="1280">
	<meta property="og:image:height" content="640">
	<meta name="twitter:image" content="{{openGraphImage}}">
	{{else}}
	<meta property="og:image" content="{{@shared.assetsHost}}/img/og-globalping.png">
	<meta property="og:image:secure_url" content="{{@shared.assetsHost}}/img/og-globalping.png">
	<meta property="og:image:width" content="1280">
	<meta property="og:image:height" content="640">
	<meta name="twitter:image" content="{{@shared.assetsHost}}/img/og-globalping.png">
	{{/if}}

	<meta name="twitter:card" content="summary_large_image">
	<meta name="twitter:title" content="{{ogTitle || title || 'Globalping - Internet and web infrastructure monitoring and benchmarking'}}">
	<meta name="twitter:description" content="{{ogDescription || description || 'Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.'}}">
	<meta name="twitter:site" content="@jsdelivr">
	<meta name="twitter:creator" content="@jsdelivr">
	<title>{{title || 'Globalping - Internet and web infrastructure monitoring and benchmarking'}}</title>

	<link rel="icon" type="image/x-icon" href="{{publicRoot}}/icons/favicon.ico">
	<link rel="icon" type="image/svg+xml" href="{{publicRoot}}/icons/favicon.svg">
	<link rel="icon" type="image/png" sizes="48x48" href="{{publicRoot}}/icons/favicon-48x48.png">
	<link rel="icon" type="image/png" sizes="32x32" href="{{publicRoot}}/icons/favicon-32x32.png">
	<link rel="icon" type="image/png" sizes="16x16" href="{{publicRoot}}/icons/favicon-16x16.png">
	<link rel="apple-touch-icon" sizes="180x180" href="{{publicRoot}}/icons/apple-touch-icon.png">
	<link rel="manifest" href="{{publicRoot}}/icons/site.webmanifest">
	<link rel="mask-icon" href="{{publicRoot}}/icons/safari-pinned-tab.svg" color="#e64e3d">
	<meta name="apple-mobile-web-app-title" content="Globalping">
	<meta name="application-name" content="Globalping">
	<meta name="msapplication-TileColor" content="#ffffff">
	<meta name="msapplication-config" content="{{publicRoot}}/icons/browserconfig.xml">
	<meta name="theme-color" content="#ffffff">
	{{>seo ~/rootContext}}
{{/partial}}

{{#if !@shared.isServer}}
	{{yield}}
{{else}}
	<!DOCTYPE html>
	<html lang="en">
		<head>
			<meta charset="utf-8">
			<r-meta></r-meta>

			<!-- Static part that doesn't change after the initial render. -->

			<!-- Maybe will be useful in Firefox at some point. -->
			<link rel="dns-prefetch" href="https://cdn.jsdelivr.net/">
<!--			<link rel="dns-prefetch" href="https://datum.jsdelivr.com/">-->

			<link rel="preconnect" href="https://cdn.jsdelivr.net/" crossorigin="anonymous">
<!--			<link rel="preconnect" href="https://datum.jsdelivr.com/" crossorigin="anonymous">-->

			<link rel="stylesheet" href="{{@shared.assetsHost}}/css/app.css?v={{@shared.assetsVersion}}">
			<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/font-awesome@4.7.0/css/font-awesome.min.css" media="print" onload="this.media='all'">

			<link rel="sitemap" href="/sitemap/index.xml" type="application/xml">

			<style>
				@font-face {
					font-family: 'Lexend';
					font-style: normal;
					font-weight: 100 900;
					src: url(https://cdn.jsdelivr.net/fontsource/fonts/lexend:vf@latest/latin-wght-normal.woff2) format('woff2-variations');
				}

				@font-face {
					font-family: 'Source Code Pro';
					font-style: normal;
					font-weight: 200 900;
					src: url(https://cdn.jsdelivr.net/fontsource/fonts/source-code-pro:vf@latest/latin-wght-normal.woff2) format('woff2-variations');
				}
			</style>

			<script type="application/ld+json">
				{
					"@context": "https://schema.org",
					"@type": "Organization",
					"name": "Globalping",
					"alternateName": "globalping",
					"description": "A global, open source, network testing and monitoring platform",
					"url": "https://globalping.io",
					"logo": "https://cdn.jsdelivr.net/gh/jsdelivr/globalping-media@refs/heads/master/logo/full_colored_dark.svg",
					"sameAs": [
						"https://x.com/jsdelivr",
						"https://www.linkedin.com/company/globalping/",
						"https://github.com/jsdelivr/globalping"
					]
				}
			</script>

			{{yield css}}
		</head>

		<body>
			<div id="page">
				{{#unless noYield}}{{yield}}{{/unless}}
			</div>

			<r-serialize></r-serialize>

			<script class="prerequisite-script" src="https://cdn.jsdelivr.net/npm/jquery@3.6.3/dist/jquery.slim.min.js" onload="this.loaded=true"></script>
			<script class="prerequisite-script" src="https://cdn.jsdelivr.net/npm/bootstrap@3.3.7/dist/js/bootstrap.js" onload="this.loaded=true"></script>
			<script class="prerequisite-script" src="https://cdn.jsdelivr.net/npm/clipboard@2.0.11/dist/clipboard.min.js" onload="this.loaded=true"></script>
			<script src="https://cdn.jsdelivr.net/npm/@algolia/autocomplete-js@1.18.1/dist/umd/index.production.min.js"></script>
			{{yield js}}
			<script type="module" src="{{@shared.assetsHost}}/js/app.js?v={{@shared.assetsVersion}}"></script>
			<script defer data-domain="globalping.io" src="https://datum.jsdelivr.com/js/script.js"></script>
		</body>
	</html>
{{/if}}


<script>
	component.exports = {
		data () {
			return {
				publicRoot: '',
			};
		},
		onrender () {
			document.querySelectorAll(`.${Ractive.sharedGet('R_META_CLASS')}`).forEach(e => e.remove());
			// eslint-disable-next-line new-cap
			app.meta = new this.components['r-meta']({ el: document.head, append: document.querySelector('meta').nextElementSibling, parent: this });
		},
		onunrender () {
			app.meta.teardown();
		},
	};
</script>
